import { generateUnOrderedList, getCircleTypeListItem, getSquareTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList";

export const FigureDesc55 = {
    title: "Figure 55: Typical floor plan for Chambers of the PP/GP. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The plan provides for office space for the staff of the PP/GP at the top, and the chambers of the PP/GP with an attached waiting area and washroom facilities at the bottom. The features are described for each space from right to left.
        </p>
        <p>
            <span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Office space for PP/GP staff:
                        {getCircleTypeListItem([
                            "The office space measures 7100 mm x 9750 mm. ",
                            "A public entrance is provided at the bottom right of the layout. ",
                            "Two information kiosks are present at the right side of the room, along with a small storage facility along the right wall. Drinking water provisions are situated at the top-right corner, along the same wall.",
                            "Two conference tables, each with 12-person seating facilities including accessible seating provisions with a turning diameter of 1500 mm, have been provided in the room.",
                            "Each table is equipped with digital technology, including computer systems and other IT facilities.",
                            "Storage is additionally provided along the walls at the left corner of the room. ",

                        ])}
                    </>,
                    <>
                        PP/GP chambers:
                        {getCircleTypeListItem([
                            "The public entrance is provided at the right side of the layout.",
                            "At the top-right side of the layout, the GP room (3000 mm x 2950 mm) is located. This room consists of a table with a seating facility for the GP and two chairs on the other side for visitors. An accessible ramp is also provided behind the GP’s chair.",
                            "To the left of the GP room, the PP room (3000 mm x 2950 mm) is located. The room consists of the same facilities as in the GP room.",
                            "At the bottom-right side of the layout, a waiting area with accessible seating provisions is located. ",
                            "Next to the waiting area, a room for the PP/GP clerks is located, with two separate desks and chairs equipped with digital technology.",
                            <>
                                The washrooms are located towards the left half of the layout.
                                {getSquareTypeListItem([
                                    "A gender-neutral, accessible washroom (2350 mm x 2750 mm) is located at the top-left. The washroom has western water closets and a washbasin, with a turning diameter of 1500 mm.",
                                    "A similar washroom, with the same dimensions and amenities, is located at the bottom-left.",
                                    "Both washrooms are separated with an aisle space, where drinking water has been provided.",

                                ])}
                            </>
                        ])}
                    </>,


                ])}
            </div>
        </p>
    </>
}

